'use client';

import {
  TalkWithUs,
  type TalkWithUsProps,
  type TalkWithUsVariant,
} from '@/features/cards/primitives/TalkWithUs';
import { openCrispChat, type CrispChatMetadata, type PlatformChatSource } from '@/shared/lib/crisp';
import { useAuthStore } from '@/shared/stores/auth-store';
import type { LucideIcon } from 'lucide-react';
import { useCallback } from 'react';

export interface TalkWithUsButtonProps {
  source: PlatformChatSource;
  metadata?: CrispChatMetadata;
  variant?: TalkWithUsVariant;
  label?: TalkWithUsProps['label'];
  icon?: LucideIcon;
  className?: string;
}

/**
 * Container for the closed-world `<TalkWithUs>` primitive. On click, opens
 * Crisp chat tagged with `source` (segment) and `metadata` (session:data),
 * and fires the `platform_chat_opened` PostHog event.
 */
export function TalkWithUsButton({
  source,
  metadata,
  variant,
  label,
  icon,
  className,
}: TalkWithUsButtonProps) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);

  const handleClick = useCallback(() => {
    openCrispChat(source, metadata ?? {}, { isAuthenticated });
  }, [source, metadata, isAuthenticated]);

  return (
    <TalkWithUs
      onClick={handleClick}
      {...(variant !== undefined && { variant })}
      {...(label !== undefined && { label })}
      {...(icon !== undefined && { icon })}
      {...(className !== undefined && { className })}
    />
  );
}
